import { Mail } from "lucide-react";
import { useState } from "react";
import { db } from "../db.ts";
import { Spinner } from "./Spinner.tsx";

export const Auth = () => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [sentCode, setSentCode] = useState(false);

  const handleSendCode = async () => {
    setLoading(true);
    try {
      if (!email) {
        setMessage("Please enter an email");
        setLoading(false);
        return;
      }
      await db.auth.sendMagicCode({ email });
      setSentCode(true);
      setMessage("Check your email for the code");
    } catch (error) {
      console.error("Auth error:", error);
      setMessage(
        error instanceof Error ? error.message : "Error sending code",
      );
    }
    setLoading(false);
  };

  const handleVerifyCode = async () => {
    setLoading(true);
    try {
      if (!code) {
        setMessage("Please enter the code");
        setLoading(false);
        return;
      }
      await db.auth.signInWithMagicCode({ email, code });
      setMessage("Signed in successfully!");
    } catch (error) {
      console.error("Verification error:", error);
      setMessage(
        error instanceof Error ? error.message : "Invalid code",
      );
    }
    setLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-[#1a1a1a] to-black">
      <div className="w-full max-w-md px-4">
        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-8 shadow-2xl">
          <h1 className="text-4xl font-bold text-white mb-2 text-center">
            Agent FOMO
          </h1>
          <p className="text-gray-400 text-center mb-8">
            Discover events that match your vibe
          </p>

          <div className="space-y-4">
            <div className="relative">
              <Mail
                className="absolute left-3 top-3 text-gray-500"
                size={20}
              />
              <input
                type="email"
                placeholder="your@email.com"
                value={email}
                // @ts-expect-error we can add dom to lib in deno.json but this introcues other issues.
                onChange={(e) => setEmail(e.target.value)}
                disabled={sentCode}
                className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition disabled:opacity-50"
              />
            </div>

            {sentCode && (
              <div>
                <input
                  type="text"
                  placeholder="Enter code from email"
                  value={code}
                  // @ts-expect-error we can add dom to lib in deno.json but this introcues other issues.
                  onChange={(e) => setCode(e.target.value)}
                  className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition"
                />
              </div>
            )}

            <button
              type="button"
              onClick={sentCode ? handleVerifyCode : handleSendCode}
              disabled={loading || !email || (sentCode && !code)}
              className="w-full bg-purple-600 hover:bg-purple-700 disabled:opacity-50 text-white font-semibold py-3 rounded-lg transition transform hover:scale-105 active:scale-95"
            >
              {loading
                ? <Spinner className="h-5 w-5 mx-auto" />
                : sentCode
                ? "Verify Code"
                : "Send Code"}
            </button>

            {message && (
              <p className="text-center text-sm text-gray-400 mt-4">
                {message}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
